import React, { useState } from 'react';
import { useHistory, Link, useRouteMatch } from 'react-router-dom';
import { COLORS } from '~/styles/colors';

import {
	Container,
	Header,
	Logo,
	LogoContainer,
	Menu,
	MenuItem,
	MenuContainer,
	RespContainer,
	MenuIcon,
} from './styles';

const Navbar = () => {
	const history = useHistory();

	const { path } = useRouteMatch();

	const [menuOpened, setMenuOpened] = useState(false);

	return (
		<Container>
			<Header>
				<RespContainer>
					<LogoContainer onClick={() => history.push('/')}>
						<Logo />
						<span style={{ color: COLORS.fgSecondary }}>
							Geoportal
						</span>
					</LogoContainer>
					<MenuIcon onClick={() => setMenuOpened(!menuOpened)} />
				</RespContainer>

				<MenuContainer>
					<Menu opened={menuOpened}>
						<MenuItem active={path === '/' || path === '/article'}>
							<Link to="/">Início</Link>
						</MenuItem>
						<MenuItem active={path === '/map'}>
							<Link to="/map">Mapas Interativos</Link>
						</MenuItem>
						{/* <MenuItem
							active={
								path === '/downloads' ||
								path.includes('/downloads/')
							}
						>
							<Link to="/downloads">Downloads</Link>
						</MenuItem> */}
						 <MenuItem active={path === '/services'}>
							<Link to="/services">Emissão de Documentos</Link>
						</MenuItem> 
						{/* <MenuItem active={path === '/help'}>
							<Link to="/help">Ajuda</Link>
						</MenuItem> */}
						<MenuItem active={false}>
							<a href="https://geo.divinopolis.mg.gov.br">Servidor</a>
						</MenuItem>
					</Menu>
				</MenuContainer>
			</Header>
		</Container>
	);
};

export default Navbar;
